import React from 'react';
import { CheckIcon, GiftIcon } from 'lucide-react';
import { SectionCta } from '../SectionCta';
import { bonuses } from '../../data/content';
export function Bonuses() {
  return <section className="bg-ink-900 px-3 py-16 text-white md:px-8 md:py-24" data-id="element-97" data-mp="1ckwmoevoutp3">
      <div className="mx-auto max-w-5xl" data-id="element-98" data-mp="1citnb48nbo7p">
        <div className="mx-auto max-w-3xl px-1 text-center" data-id="element-99" data-mp="18kdtage5dfks">
          <GiftIcon className="mx-auto h-12 w-12 text-cta-400" aria-hidden="true" data-id="element-100" data-mp="18hrogoin5e69" />
          <p className="mt-3 text-sm font-extrabold uppercase tracking-wide text-brand-300" data-id="element-101" data-mp="257r412x7lcyc">
            But your complete clinical toolkit doesn't stop there
          </p>
          <h2 className="mt-3 text-[28px] font-extrabold leading-tight tracking-tight md:text-[42px]" data-id="element-102" data-mp="1w7u8qigbdfub">
            Today, you also receive <span className="text-cta-400" data-id="element-103" data-mp="1rc6kq6dkisqe">5 practical bonuses</span>
          </h2>
          <p className="mt-4 text-[17px] leading-relaxed text-mist-200" data-id="element-104" data-mp="kvbd7cz5vuse">
            Complementary tools designed to make the blueprint easier to implement in your existing professional workflow.
          </p>
        </div>

        <div className="mt-12 space-y-8" data-id="element-105" data-mp="1eru4ksv8ures">
          {bonuses.map((b, i) => <article key={b.number} className="overflow-hidden rounded-3xl bg-ink-800 ring-1 ring-white/10 md:grid md:grid-cols-2 md:items-center" data-id="element-106" data-mp="1jryjiegi7e2w" data-mpi={i}>
              <div className={`bg-white ${i % 2 === 1 ? 'md:order-2' : ''}`} data-id="element-107" data-mp="1aqiaob5c7k0s">
                <img src={b.image} alt={`Bonus ${b.number} — ${b.title}`} className="block w-full" loading="lazy" data-id="element-108" data-mp="w24881bu1xkr" />
              </div>
              <div className="p-6 md:p-8" data-id="element-109" data-mp="10vypky3yu0go">
                <div className="flex flex-wrap items-center gap-3" data-id="element-110" data-mp="n30n6rt3v83m">
                  <span className="rounded-lg bg-cta-400 px-3 py-1 text-sm font-extrabold uppercase text-ink-950" data-id="element-111" data-mp="n0o1q4o52flt">
                    Bonus {b.number}
                  </span>
                  <span className="text-sm font-bold text-mist-300" data-id="element-112" data-mp="d530w9ut3ldn">
                    Reference value: <span className="line-through" data-id="element-113" data-mp="i2uvjbmu5llj">{b.value}</span>{' '}
                    <span className="text-brand-300" data-id="element-114" data-mp="2jstls5uuzoo3">Included free</span>
                  </span>
                </div>
                <h3 className="mt-3 text-2xl font-extrabold leading-tight" data-id="element-115" data-mp="2f11x60v9jt0l">{b.title}</h3>
                <p className="mt-3 text-[16px] leading-relaxed text-mist-200" data-id="element-116" data-mp="2b1b8c2parmyp">{b.description}</p>
                <ul className="mt-4 space-y-2" data-id="element-117" data-mp="26280ybluh4nk">
                  {b.items.map(it => <li key={it} className="flex items-start gap-2.5 text-[15px] font-semibold" data-id="element-118" data-mp="32rpibnu6wf53">
                      <CheckIcon className="mt-0.5 h-5 w-5 shrink-0 text-brand-400" strokeWidth={3} aria-hidden="true" data-id="element-119" data-mp="2ypkqmunaxsl3" />
                      {it}
                    </li>)}
                </ul>
              </div>
            </article>)}
        </div>

        <div className="px-1" data-id="element-120" data-mp="1ibb322qvw7vb">
          <SectionCta label="Claim my 5 bonuses today" tone="dark" data-id="element-121" data-mp="1icm7m4s5ljnh" />
        </div>
      </div>
    </section>;
}